// "Subscription" tab.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';
import type { ActionRequestBody } from '../api/types.js';

// Reserved for calls: RECHARGE_CHANGE_CADENCE, RECHARGE_PAUSE,
// RECHARGE_RESUME, RECHARGE_CANCEL, RECHARGE_SKIP_NEXT,
// RECHARGE_UPDATE_NEXT_CHARGE_DATE, RECHARGE_UPDATE_QUANTITY,
// RECHARGE_SWAP_PRODUCT, RECHARGE_ADD_ONE_TIME.
export type SubscriptionCall = ActionRequestBody;

export function Subscription(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Subscription"
      wiringNotes="Reads Recharge subscription state, then fires cadence, pause, resume, skip, quantity, and swap actions via /v1/actions/RECHARGE_*."
    />
  );
}
